/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListMemoryStoresQueryParamOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ListMemoryStoresQueryParamOrder = ClosedEnum<
  typeof ListMemoryStoresQueryParamOrder
>;

export type ListMemoryStoresRequest = {
  limit?: number | undefined;
  order?: ListMemoryStoresQueryParamOrder | undefined;
  after?: string | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListMemoryStoresQueryParamOrder$inboundSchema: z.ZodNativeEnum<
  typeof ListMemoryStoresQueryParamOrder
> = z.nativeEnum(ListMemoryStoresQueryParamOrder);
/** @internal */
export const ListMemoryStoresQueryParamOrder$outboundSchema: z.ZodNativeEnum<
  typeof ListMemoryStoresQueryParamOrder
> = ListMemoryStoresQueryParamOrder$inboundSchema;

/** @internal */
export const ListMemoryStoresRequest$inboundSchema: z.ZodType<
  ListMemoryStoresRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  limit: z.number().int().default(20),
  order: ListMemoryStoresQueryParamOrder$inboundSchema.default("desc"),
  after: z.string().optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListMemoryStoresRequest$Outbound = {
  limit: number;
  order: string;
  after?: string | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListMemoryStoresRequest$outboundSchema: z.ZodType<
  ListMemoryStoresRequest$Outbound,
  z.ZodTypeDef,
  ListMemoryStoresRequest
> = z.object({
  limit: z.number().int().default(20),
  order: ListMemoryStoresQueryParamOrder$outboundSchema.default("desc"),
  after: z.string().optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listMemoryStoresRequestToJSON(
  listMemoryStoresRequest: ListMemoryStoresRequest,
): string {
  return JSON.stringify(
    ListMemoryStoresRequest$outboundSchema.parse(listMemoryStoresRequest),
  );
}
export function listMemoryStoresRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListMemoryStoresRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListMemoryStoresRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListMemoryStoresRequest' from JSON`,
  );
}
